import React from 'react';
import { useNavigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import './HeroSectionNew.css';
import { saveUserQuizAnswers } from '../../../api/api';

const HeroSectionNew = ({ setSelectedGender, basePath, funnelName, funnelVersion }) => {
  const navigate = useNavigate();

  const trackSelectGender = (gender) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'dl_select_gender',
        experimentGroup: 'control',
        gender,
      },
    });
  };

  const handleClick = (goal) => {
    trackSelectGender(goal);
    localStorage.setItem('initialGoal', goal);

    const userId = localStorage.getItem("userId");
    if (userId) {
      saveUserQuizAnswers(userId, "What's your goal?", [goal], funnelName, funnelVersion);
    }

    navigate(`${basePath}/question/1`);
  };

  return (
    <div className="hero-container">
      <h2 className="hero-title">The easiest way to grow your sales with AI</h2>
      <p className="hero-subtitle">Get your AI growth plan</p>
      <div className="hero-cover-image">
        <img src="../assets/images/ad1/lp-cover2.webp" alt="Sales growth transformation" />
      </div>
      {/* <div className="hero-quiz-invite">2-MINUTE QUIZ</div> */}
      <p className="hero-question">What's your goal?</p>
      <div className="hero-goal-selection">
        <div className="goal-card goal-card-primary" onClick={() => handleClick('Get first sales')}>
          Get first sales
        </div>
        <div className="goal-card goal-card-secondary" onClick={() => handleClick('Drive more sales')}>
          Drive more sales
        </div>
      </div>
      <div className="hero-social-proof">
        <p className="hero-proof-text">Trusted by <strong>30,000+</strong> businesses on</p>
        <div className="hero-proof-logos">
          <div className="hero-logo-badge">
            <img src="../assets/images/question-answers/shop-logos/etsy.png" alt="Etsy" />
            <span className="hero-badge">3k+</span>
          </div>
          <div className="hero-logo-badge">
            <img src="../assets/images/question-answers/shop-logos/amazon.png" alt="Amazon" />
            <span className="hero-badge">11k+</span>
          </div>
          <div className="hero-logo-badge">
            <img src="../assets/images/question-answers/shop-logos/shopify.png" alt="Shopify" />
            <span className="hero-badge">8k+</span>
          </div>
          <div className="hero-logo-badge">
            <img src="../assets/images/question-answers/shop-logos/instagram.png" alt="Instagram" />
            <span className="hero-badge">8k+</span>
          </div>
        </div>
      </div>
    </div>
  );

};


export default HeroSectionNew;
